import { Tabs } from 'antd';
import React from 'react';
import VideoTopics from './VideoTopics';

const VideoChapters = ({ subjectChapters }) => {
  return (
    <Tabs
      title="Chapters"
      defaultActiveKey="1"
      tabPosition={'left'}
      items={
        subjectChapters &&
        subjectChapters.map((chapter, index) => {
          return {
            label: chapter.chapterName,
            key: index + 1,
            children: (
              <div className="min-w-max">
                <VideoTopics chapterTopics={chapter && chapter.topics ? chapter.topics : []} />
              </div>
            ),
          };
        })
      }
    ></Tabs>
  );
};

export default VideoChapters;
